/**
 * This file is the entry point for Webpack.
 * It dynamically imports bootstrap.js to ensure that shared modules
 * (like React and ReactDOM) are loaded correctly for Module Federation.
 */
import("./bootstrap");
